import React from 'react';
import {
  CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { MilitaryDisciplinaryProceduresItemModel } from 'forms/sections/military/disciplinary/types';
import { setAttribute } from 'components/Form/shared/setAttribute';
import DisciplinaryPvq from './DisciplinaryPvq';

interface Props extends ValidationElementProps {
  $index?: number;
  attribute?: string;
  bind?: boolean;
  className?: string;
  formType?: string;
  name: string;
  onError?: CommonOnError;
  onUpdate?: (value: Partial<MilitaryDisciplinaryProceduresItemModel>) => void;
  required?: CommonRequired;
  scrollIntoView?: CommonScrollIntoView;
}

interface ItemProps
  extends Props,
  Partial<MilitaryDisciplinaryProceduresItemModel> {}

export default class DisciplinaryCollectionItem extends ValidationElement<ItemProps> {
  static defaultProps: ItemProps = {
    Comments: {} as MilitaryDisciplinaryProceduresItemModel['Comments'],
    Court: {} as MilitaryDisciplinaryProceduresItemModel['Court'],
    Date: {} as MilitaryDisciplinaryProceduresItemModel['Date'],
    Name: {} as MilitaryDisciplinaryProceduresItemModel['Name'],
    Offenses: {} as MilitaryDisciplinaryProceduresItemModel['Offenses'],
    Outcome: {} as MilitaryDisciplinaryProceduresItemModel['Outcome'],
    // PVQ-only below
    CourtMartialCircumstances: {} as MilitaryDisciplinaryProceduresItemModel['CourtMartialCircumstances'],
    CourtMartialLocation: { isMilitaryDiplomaticAddress: {
      value: 'Yes',
    }
    } as MilitaryDisciplinaryProceduresItemModel['CourtMartialLocation'],
    CourtMartialOffenseDate: {} as MilitaryDisciplinaryProceduresItemModel['CourtMartialOffenseDate'],
    CourtMartialOffenseLocation: {} as MilitaryDisciplinaryProceduresItemModel['CourtMartialOffenseLocation'],
    CourtMartialType: {} as MilitaryDisciplinaryProceduresItemModel['CourtMartialType'],
    DisciplinaryDate: {} as MilitaryDisciplinaryProceduresItemModel['DisciplinaryDate'],
    DisciplinaryProcedureName: {} as MilitaryDisciplinaryProceduresItemModel['DisciplinaryProcedureName'],
    DisciplinaryProcedureOtherExplanation: {} as MilitaryDisciplinaryProceduresItemModel['DisciplinaryProcedureOtherExplanation'],
    GivenBy: {} as MilitaryDisciplinaryProceduresItemModel['GivenBy'],
    GivenByNotApplicable: { applicable: true },
    Has: {} as MilitaryDisciplinaryProceduresItemModel['Has'],
    InvolvedAlcohol: {} as MilitaryDisciplinaryProceduresItemModel['InvolvedAlcohol'],
    InvolvedDomesticViolence: {} as MilitaryDisciplinaryProceduresItemModel['InvolvedDomesticViolence'],
    InvolvedDrugs: {} as MilitaryDisciplinaryProceduresItemModel['InvolvedDrugs'],
    InvolvedExplosives: {} as MilitaryDisciplinaryProceduresItemModel['InvolvedExplosives'],
    InvolvedFirearms: {} as MilitaryDisciplinaryProceduresItemModel['InvolvedFirearms'],
    List: {} as MilitaryDisciplinaryProceduresItemModel['List'],
    ReportedWithEmployment: {} as MilitaryDisciplinaryProceduresItemModel['ReportedWithEmployment'],
    WhatHappened: {} as MilitaryDisciplinaryProceduresItemModel['WhatHappened'],
    // non-Model properties below
    name: '',
  };

  update = (queue: Partial<MilitaryDisciplinaryProceduresItemModel>) => {
    if (this.props.onUpdate) {
      this.props.onUpdate({
        Comments: this.props.Comments,
        Court: this.props.Court,
        Date: this.props.Date,
        DisciplinaryProcedureName: this.props.DisciplinaryProcedureName,
        DisciplinaryProcedureOtherExplanation: this.props.DisciplinaryProcedureOtherExplanation,
        Has: this.props.Has,
        Name: this.props.Name,
        Offenses: this.props.Offenses,
        Outcome: this.props.Outcome,
        ...queue,
      });
    }
  };

  onUpdateList = (values: Partial<MilitaryDisciplinaryProceduresItemModel>) => {
    this.update({ ...values });
  };

  render() {
    const attribute: string | undefined = setAttribute(this.props.attribute, `items[${this.props.$index}].Item`);

    return (
      <DisciplinaryPvq
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        attribute={attribute}
        bind
        formType={this.props.formType}
        name="Item"
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        onError={this.props.onError}
        onUpdate={this.onUpdateList}
        required={this.props.required}
      />
    );
  }
}
